"use client"
import { Link } from "react-router-dom"
import "./Sidebar.css"

const Sidebar = ({ menuItems, isOpen, toggleSidebar, currentPath, userRole }) => {
  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <div className="logo-container">
          <img src={require('../../images/icon.png')} alt="Christ Light Assemblies Logo" className="logo" />
          <h1 className="logo-text">Christ Light</h1>
        </div>
        <button className="close-sidebar" onClick={toggleSidebar}>
          <i className="material-icons">close</i>
        </button>
      </div>

      <div className="sidebar-content">
        <div className="user-info">
          <div className="user-avatar">
            <img src={require('../../images/Untitled.jpeg')} alt="User Avatar" />
          </div>
          <div className="user-details">
            <h3 className="user-name">{userRole === "admin" ? "Admin User" : "Mentor User"}</h3>
            <p className="user-role">{userRole === "admin" ? "Administrator" : "Mentor"}</p>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {menuItems.map((item, index) => (
              <li key={index} className={`nav-item ${currentPath === item.path ? "active" : ""}`}>
                <Link to={item.path} className="nav-link" onClick={() => window.innerWidth < 768 && toggleSidebar()}>
                  <i className="material-icons">{item.icon}</i>
                  <span className="nav-text">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="sidebar-footer">
        <p>&copy; 2025 Christ Light Assemblies</p>
      </div>
    </div>
  )
}

export default Sidebar
